import React from "react"
import { Navigate } from "react-router-dom";

const CommonRoute = ({ children }) => {
    const authed = localStorage.getItem("secretToken");

    return authed ? children : <Navigate to={"/"} />
}

export default CommonRoute;